import { render, staticRenderFns } from "./mails_square.vue?vue&type=template&id=36f0239a&scoped=true&"
import script from "./mails_square.vue?vue&type=script&lang=js&"
export * from "./mails_square.vue?vue&type=script&lang=js&"
import style0 from "./mails_square.vue?vue&type=style&index=0&id=36f0239a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f0239a",
  null
  
)

export default component.exports